import { make } from 'vuex-pathify';
import { state as productUpgrade } from '@/store/productUpgrade';

const mutations = {
  ...make.mutations(productUpgrade),
};

export { mutations };
